import axios from "axios";

export const getProducts = async () => {
  const res = await axios.get("https://alnabaatech.com.ly/api/products");
  return res.data.data;
};